module.exports = __webpack_public_path__ + "static/img/200208.d15df92b.png";